// src/services/catchLog.ts
import {
  addDoc,
  collection,
  onSnapshot,
  serverTimestamp,
  Unsubscribe,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

export type CatchLogEntry = {
  id: string;
  userId: string;

  species: string; // e.g. "Bluegill"
  notes?: string | null;

  locationName?: string | null;
  lat?: number | null;
  lng?: number | null;

  createdAt?: any;
  updatedAt?: any;
};

export async function addCatchLogEntry(
  userId: string,
  entry: Omit<CatchLogEntry, 'id' | 'userId' | 'createdAt' | 'updatedAt'>,
): Promise<string> {
  const colRef = collection(db, 'users', userId, 'catchLog');

  const payload = {
    ...entry,
    userId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  const docRef = await addDoc(colRef, payload);
  return docRef.id;
}

export function subscribeToCatchLog(
  userId: string,
  onEntries: (entries: CatchLogEntry[]) => void,
  onError?: (err: unknown) => void,
): Unsubscribe {
  const colRef = collection(db, 'users', userId, 'catchLog');

  // Legacy compatibility must expose the complete collection so the client
  // timeline and server public projection dedupe the same inventory.
  return onSnapshot(
    colRef,
    (snap) => {
      const entries = snap.docs.map((d) => ({
        id: d.id,
        ...(d.data() as any),
      })) as CatchLogEntry[];
      onEntries(entries);
    },
    (err) => {
      if (onError) onError(err);
      else console.error('[catchLog] subscribeToCatchLog error', err);
    },
  );
}